import React from "react";

import { withRouter } from "../util/liexRouter";
import { genericPost } from "../util/dataLoader";
import {
  API_BASE_URL,
  API_GET_DATA_FOR_EMAIL_CHANGE_URL,
  API_UPDATE_EMAIL_URL,
} from "../api/liex";
import appg from "../appg";
import liex from "../api/liex";

class ChangeEmail extends React.Component {
  state = {
    fullname: "",
    oldemail: "",
    newemail: "",
    smscode: "",
    server_code: "",
    error: "",
  };

  componentDidMount() {
    if (!this.props.router.params.token) {
      this.setState({ error: "Token no encontrado" });
    } else {
      let token = this.props.router.params.token;
      genericPost(
        API_BASE_URL + API_GET_DATA_FOR_EMAIL_CHANGE_URL,
        "No es posible solicitar informacion para actualizar correo.",
        { token: token },
        (data) => {
          this.setState({
            newemail: data.newemail,
            oldemail: data.oldemail,
            fullname: data.fullname,
            server_code: data.sms_code,
          });
          //   console.log(this.state);
        }
      );
    }
  }

  onSubmit = (event) => {
    event.preventDefault();
  };

  onSubmitClick = async (event) => {
    event.preventDefault();
    // console.log(this.state);

    if (this.state.smscode === "") {
      this.setState({ error: "Por favor ingrese codigo enviado por SMS." });
      return;
    }

    if (this.state.smscode !== this.state.server_code) {
      this.setState({
        error: "El código SMS no coincide con el que se envio a su telefono",
      });
      return;
    }

    let token = this.props.router.params.token;
    let payload = {
      token: token,
      smscode: this.state.smscode,
    };
    // console.log(payload);

    try {
      const res = await liex.post(API_BASE_URL + API_UPDATE_EMAIL_URL, payload);
      appg.toast.show({
        severity: "success",
        summary: "Correo actualizado",
        detail: res.data.message + " Ya puede cerrar esta ventana.",
      });
    } catch (error) {
      if (error.response.data) {
        appg.toast.show({
          severity: "error",
          summary: "Error al actualizar correo",
          detail: error.response.data.message,
        });
      }
    }
    this.setState({ error: "" });
  };

  messageClass = () => {
    return this.state.error
      ? "ui alert alert-danger"
      : "ui alert alert-success";
  };

  renderMessage = (isError) => {
    if (this.state.error) {
      return (
        <div
          className={this.messageClass()}
          style={{ marginTop: 20 }}
          role="alert"
        >
          <h3>{this.state.error}</h3>
        </div>
      );
    }
  };

  render() {
    return (
      <div className="ui container">
        <h1>Restablecer correo electronico</h1>
        <div className="ui form">
          <div className="field">
            <label>Usuario</label>
            <input
              type="text"
              defaultValue={this.state.fullname}
              disabled={true}
            />
          </div>
          <div className="field">
            <label>Correo actual</label>
            <input
              type="text"
              defaultValue={this.state.oldemail}
              disabled={true}
            />
          </div>
          <div className="field">
            <label>Correo nuevo</label>
            <input
              type="text"
              defaultValue={this.state.newemail}
              disabled={true}
            />
          </div>
        </div>
        <div className="ui divider"> </div>
        <form className="ui form" onSubmit={this.onSubmit}>
          <div className="field">
            <label>Código SMS</label>
            <input
              type="text"
              autoFocus={true}
              name="smscode"
              placeholder="sms"
              value={this.state.smscode}
              onChange={(e) => this.setState({ smscode: e.target.value })}
            />
          </div>
          <button
            className="ui button"
            type="submit"
            onClick={this.onSubmitClick}
          >
            Actualizar correo
          </button>
        </form>
        {this.renderMessage()}
      </div>
    );
  }
}

export default withRouter(ChangeEmail);
